export default __webpack_public_path__ + "static/media/policy-disabled.141a3904.svg";